import {
  Box,
  Flex,
  Text,
  Image,
  useBreakpointValue,
  HStack,
} from "@chakra-ui/react";
import Fade from "react-reveal/Fade";
import React, { useState } from "react";

const CrossChain = () => {
  const isXLScreen = useBreakpointValue({ base: false, xl: true });
  const isSmallScreen = useBreakpointValue({ base: true, xl: false });
  const [selectedOption, setSelectedOption] = useState(
    "Cross-Chain Transactions"
  );

  const handleOptionClick = (option) => {
    setSelectedOption(option);
  };

  const getContainerStyles = (option) => ({
    borderRadius: "5px",
    background: selectedOption === option ? "#FFF" : "white",
    boxShadow:
      selectedOption === option
        ? "0px 4px 10px 0px rgba(0, 0, 0, 0.10)"
        : "none",
    color: selectedOption === option ? "#FD8534" : "#999",
    fontWeight: selectedOption === option ? "600" : "500",
    transition: "all 0.3s ease-in-out",
  });

  const optionDescriptions = {
    "Cross-Chain Transactions":
      "A-On Fi Network breaks down silos, connecting major financial institutions for seamless cross-chain transactions.",
    "Interoperability Across Blockchains":
      "A-On Fi Network ensures interoperability by connecting and facilitating transactions across different blockchain networks.",
    "On-Chain Identity Verification":
      "Seamlessly integrate on-chain identity verification to enhance security and trust in your financial transactions.",
  };

  const optionImages = {
    "Cross-Chain Transactions": require("../../../../assets/images/aOnFiNetwork/Group.png"),
    "Interoperability Across Blockchains": require("../../../../assets/images/aOnFiNetwork/1.png"),
    "On-Chain Identity Verification": require("../../../../assets/images/aOnFiNetwork/2.png"),
  };

  return (
    <Box backgroundColor="#F9F9F9">
      <Box
        paddingBottom={{ base: "30px", xl: "100px" }}
        className={isXLScreen ? "container" : "container-responsive"}
      >
        <Box>
          <Flex
            alignItems={{ base: "start", xl: "center" }}
            flexDirection="column"
            paddingTop="100px"
          >
            <HStack
              width="100%"
              spacing="0"
              flexDirection={{ base: "column", lg: "row" }}
            >
              {Object.keys(optionDescriptions).map((option) => (
                <Text
                  key={option}
                  width={{ base: "100%", lg: "390px" }}
                  borderRadius="5px"
                  cursor="pointer"
                  textAlign="center"
                  fontSize={{ base: "12px", xl: "16px" }}
                  lineHeight={{ base: "28px", xl: "34px" }}
                  paddingY={{ base: "15px", xl: "20px" }}
                  paddingX={{ base: "20px", xl: "35px" }}
                  marginBottom={!isXLScreen && !isSmallScreen && "10px"}
                  onClick={() => handleOptionClick(option)}
                  {...getContainerStyles(option)}
                >
                  {option}
                </Text>
              ))}
            </HStack>
            {selectedOption && (
              <Box
                paddingTop={{ base: "0px", xl: "30px" }}
                marginLeft={!isXLScreen && !isSmallScreen && "20px"}
              >
                <Flex
                  paddingY={{ base: "0px", md: "50px", xl: "0px" }}
                  alignItems={{ base: "center", md: "start" }}
                  justifyContent="space-between"
                  flexDirection={{ base: "column", lg: "row" }}
                  width="fit-content"
                >
                  <Box
                    width={{ base: "100%", lg: "50%", xl: "40%" }}
                    paddingTop={{ base: "30px", xl: "60px" }}
                  >
                    <Fade left>
                      <Text
                        cursor="pointer"
                        color="#000"
                        fontSize={{ base: "28px", xl: "36px" }}
                        fontWeight={{ base: "600", xl: "500" }}
                        lineHeight={{ base: "50px", xl: "50px" }}
                        textAlign="start"
                      >
                        {selectedOption}
                      </Text>
                      <Text
                        paddingTop={{ base: "20px", xl: "30px" }}
                        color="#666"
                        fontWeight="400"
                        fontSize={{ base: "18px", xl: "20px" }}
                        lineHeight={{ base: "28px", xl: "30px" }}
                        textAlign="start"
                      >
                        {optionDescriptions[selectedOption]}
                      </Text>
                    </Fade>
                  </Box>
                  <Flex
                    paddingY={{ base: "60px", xl: "0px" }}
                    w={{ base: "fill-available", xl: "50%" }}
                    justifyContent="center"
                  >
                    <Fade right>
                      <Image
                        h="150px"
                        src={optionImages[selectedOption]}
                        alt={`Image for ${selectedOption}`}
                        objectFit="cover"
                        borderRadius="5px"
                        marginTop={{ base: "10px", xl: "80px" }}
                      />
                    </Fade>
                  </Flex>
                </Flex>
              </Box>
            )}
          </Flex>
        </Box>
      </Box>
    </Box>
  );
};

export default CrossChain;
